//
import Model from "@/models/Model"

/**
 * @class
 */
export default class AAuthorize extends Model {
    
    /**
     * @description
     */
    resource () {
        return "authorize"
    }
}